function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.1804 12.902L42.1792 12.9031L39.2935 15.8768L37.4994 17.7255L35.7053 15.8768L32.8196 12.9031L32.8167 12.9002C26.2719 6.13371 15.8099 5.18602 8.90212 11.0719C0.8167 17.9734 0.381854 30.3951 7.62535 37.8848L42.1804 12.902ZM42.1804 12.902C48.7412 6.13244 59.1893 5.18691 66.0961 11.0715C74.1822 17.973 74.6168 30.3947 67.3593 37.8843L67.3588 37.8848L39.0146 67.1519C39.0144 67.152 39.0143 67.1522 39.0141 67.1524C38.1655 68.0276 36.8187 68.0276 35.9701 67.1524C35.9699 67.1522 35.9698 67.152 35.9696 67.1519L7.6264 37.8859L42.1804 12.902Z",
  stroke: "#67DAB8",
  strokeWidth: 5
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 75,
  fill: "white"
})));

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0441bc27.svg";
export { ForwardRef as ReactComponent };